import { Row } from "antd";
import styled from "styled-components";

import { Palette } from "../../core/styles/palette";

// Wider than antd's default (378px) so the field + "update this field" checkbox columns aren't cramped.
export const DRAWER_SIZE = 600;

// One shared label sits above the main field and its updateXxx checkbox, so the two controls underneath line up
export const FieldLabelStyle = styled.label`
    display: block;
    margin-bottom: 4px;
    font-family: "RobotoLight";
    font-size: 12pt;
    //font-size: 14px;
    color: ${Palette.AeviBlack};
`;

export const RequiredMark = styled.span`
    color: ${Palette.AeviRed};
`;

export const BatchUpdateFormRow = styled(Row)`
    gap: 40px;
`;
